/**
 * Utilidades compartidas para gestión de cotizaciones
 * @module utils/cotizacionHelpers
 */

import React from 'react';

/**
 * Configuración de estados de cotización con badges
 */
export const ESTADOS_COTIZACION = {
  borrador: { label: 'Borrador', badge: 'badge-secondary' },
  enviada: { label: 'Enviada', badge: 'badge-info' },
  aprobada: { label: 'Aprobada', badge: 'badge-success' },
  rechazada: { label: 'Rechazada', badge: 'badge-danger' },
  vencida: { label: 'Vencida', badge: 'badge-warning' }
};

/**
 * Renderiza badge de estado de cotización
 *
 * @param {string} estado - Estado de la cotización
 * @returns {JSX.Element} Badge con estilo según estado
 */
export const renderEstadoBadge = (estado) => {
  const config = ESTADOS_COTIZACION[estado] || ESTADOS_COTIZACION.borrador;

  return (
    <span className={`badge ${config.badge}`}>
      {config.label}
    </span>
  );
};

/**
 * Convierte un objeto de configuración en array de opciones para selects
 *
 * @param {Object} configObj - Objeto { key: { label, ... } }
 * @returns {Array<{value: string, label: string}>}
 */
const toSelectOptions = (configObj) =>
  Object.entries(configObj).map(([value, config]) => ({ value, label: config.label }));

/**
 * Obtiene opciones de estados para selects
 *
 * @returns {Array<{value: string, label: string}>}
 */
export const getEstadoOptions = () => toSelectOptions(ESTADOS_COTIZACION);

/**
 * Configuración de tipos de nota de cotización con badges
 */
export const TIPOS_NOTA = {
  inclusion: { label: 'Inclusión', badge: 'badge-success' },
  exclusion: { label: 'Exclusión', badge: 'badge-danger' },
  general:   { label: 'General',   badge: 'badge-secondary' }
};

/**
 * Obtiene opciones de tipos de nota para selects
 *
 * @returns {Array<{value: string, label: string}>}
 */
export const getTiposNotaOptions = () => toSelectOptions(TIPOS_NOTA);
